// import * as navbarimage from '../../images/logo.svg'; //Top-level of the document
// import tippy from 'tippy.js';

// lazy imgs
import lazySizes from "lazysizes"
lazySizes.cfg.lazyClass = 'js-lazyImg';

export default {
  init() {
    /** Tooltip */
    // tippy('[data-tippy-content]',{
    //   theme :'fclr',
    //   placement: 'top',
    //   distance: 7,
    // });

    // JavaScript to be fired on all pages
    const html = $('html');
    const body = $('body');
    const navigationOverlay = $('.js-navigation');
    // click on search
    const search = $('.js-search-trigger');
    const searchOverlay = $('.js-search');
    const close = $('.js-close');

    if ($('body').hasClass('search')) {
      searchOverlay.toggleClass('discret').toggleClass('is-open');
      search.toggleClass('is-active');
      html.toggleClass('menu-is-open');
      body.toggleClass('menu-is-open');
    }

    search.on('click', function () {
      search.toggleClass('is-active');
      searchOverlay.toggleClass('discret').toggleClass('is-open');
      $('.search-field').focus();
      html.toggleClass('menu-is-open');
      body.toggleClass('menu-is-open');
      close.toggle();
    });

    // click on close

    close.on('click', function () {
      close.toggle();
      searchOverlay.addClass('discret').removeClass('is-open');
      navigationOverlay.addClass('discret').removeClass('is-open');
      html.removeClass('menu-is-open');
      body.removeClass('menu-is-open');
    });

    /**
      * Pour les images en background
      */
    class ResponsiveBackgroundImage {

      constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';

        if (this.img) {
          this.img.addEventListener('load', () => {
            this.update();
          });
        }
        if (this.img) {
          if (this.img.complete) {
            this.update();
          }
        }
      }

      update() {
        let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
        if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = 'url("' + this.src + '")';

        }
      }
    }

    let elements = document.querySelectorAll('.js-bgImg');
    for (let i = 0; i < elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

    // TRY to combine with lazyload..
    // let $lazyimgs = $('body').find(".js-lazyImg");
    // $lazyimgs.load(function () {
    //   for (let i = 0; i < elements.length; i++) {
    //     new ResponsiveBackgroundImage(elements[i]);
    //   }
    // });

    /**
    * SVG REPLACE
    * Replace all SVG images with inline SVG
    */

    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });

    /**
     *  MMENU - Primary mobile nav
    */
    const $navMobilePrimary = $('#js-mobile-nav'),
      $navMobileHeader = document.querySelector('.js-mobile-menu-header'),
      $navMobileFooter = document.querySelector('.js-mobile-menu-footer');
    if($navMobilePrimary){
      $navMobilePrimary.mmenu(
        {
          wrappers: ['wordpress'],
          className: {
            panel: "js-mobile-menu-panel",
            selected: "active",
          },
          navbar: {
            add: false,
          },
          onClick: {
            close: false,
          },
          // offCanvas: {
          //   position: "bottom",
          // },
          //sub-menu slide or drop-down ?
          slidingSubmenus: false,
          extensions: [
            // "pagedim-black",
            "fullscreen",
            'position-top',
          ],
          navbars: [
            // sticky title in header
            {
              use: false,
              position: "top",
              content: [
                $navMobileHeader,
              ],
            },
            // sticky search in footer
            {
              use: true,
              position: "bottom",
              content: [
                $navMobileFooter,
              ],
            },
          ],
        },
        {
          // configuration
          offCanvas: {
            clone: false,
          },
        }
      );
    }
    // Bind Main Close btn
    let $mainNavClose = $('#js-mobile-menu-header-close'),
    $mainNavApi = $('#js-mobile-nav').data('mmenu');
    $mainNavClose.on('click', function (e) {
      e.preventDefault();
      $mainNavApi.close();
    });

    // Btn trigger (hamburgers css package)
    const $navTrigger = $('#js-mobile-nav-trigger'),
      $navMobileApi = $('#js-mobile-nav').data('mmenu');

      if($navMobileApi){
        $navMobileApi.bind('open:finish', function () {
          setTimeout(function () {
            $navTrigger.addClass('is-active');
          }, 50);
        });
        $navMobileApi.bind('close:finish', function () {
          setTimeout(function () {
            $navTrigger.removeClass('is-active');
          }, 50);
        });

      }

    /**
     * UserNav mobile
     * my-profile, fontend-edit tools, etc.
    */
    const $userNavPrimary = $('#js-userNav-mobile'),
      $userNavHeader = document.querySelector('.js-userNav-mobile-header'),
      $userNavFooter = document.querySelector('.js-userNav-mobile-footer');
    if($userNavPrimary){
      $userNavPrimary.mmenu(
        {
          wrappers: ['wordpress'],
          className: {
            panel: "js-userNav-mobile-panel",
            selected: "active",
          },
          navbar: {
            add: false,
          },
          onClick: {
            close: false,
          },
          //sub-menu slide or drop-down ?
          slidingSubmenus: false,
          extensions: [
            "pagedim-black",
            "fullscreen",
            'position-top',
          ],
          navbars: [
            // sticky header
            {
              use: true,
              position: "top",
              content: [
                $userNavHeader,
              ],
            },
            // sticky footer
            {
              use: true,
              position: "bottom",
              content: [
                $userNavFooter,
              ],
            },
          ],
        },
        {
          // configuration
          offCanvas: {
            clone: false,
          },
        }
      );
    }



    // Evénements suivants et passé

    const period = $('.js-calendar-select');
    period.change(function () {
      if ($(this).val() == 'past') {
        $('.past-events').show();
        $('.next-events').hide();
      } else {
        $('.past-events').hide();
        $('.next-events').show();
      } // hide div if value is not "custom"
    });

    /** back to top */

    if ($('.js-totop').length) {
      var scrollTrigger = 100, // px
        backToTop = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > scrollTrigger) {
            $('.js-totop').addClass('show');
          } else {
            $('.js-totop').removeClass('show');
          }
        };
      backToTop();
      $(window).on('scroll', function () {
        backToTop();
      });
      $('.js-totop').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0,
        }, 700);
      });
    }

    /**
     * Simple Tabs (exemple in Event Single - Admin Section )
     */
    let $tabsBtn = $('.js-tabBtn'),
      $tabs = $('.js-tabs > div');

    $tabsBtn.on('click', function () {
      const $this = $(this),
        targetId = $this.data('tab');

      $tabs.hide();
      $tabsBtn.removeClass('is-active');
      $('#' + targetId).show();
      $this.addClass('is-active');

      // Change window location to add URL params
      if (window.history && history.pushState) {
        // NOTE: doesn't take into account existing params
        history.replaceState("", "", "?tab" + "=" + targetId);
      }
    });

    /**
     * Au chargement d'une page on cherche un tab (utile dans le tableau de bord au retour de l'édition d'un profil par ex.)
     */

    var queryString = {};
    window.location.href.replace(
      new RegExp("([^?=&]+)(=([^&]*))?", "g"),
      function ($0, $1, $2, $3) { queryString[$1] = $3; }
    );
    // tab trouvé! on clique dessus
    if (queryString['tab']) {
      var tab = $("a[data-tab='" + queryString['tab'] + "']");
      tab.click();
    }

    /**
     * Case a cocher du renouvellement d'adhésion
     */
    // par defaut le bouton va vers une nouvelle adhésion
    // mais si on coche un case a cocher ça change le label du bouton

    $(".js-checkbox-member").change(function () {
      if ($('.js-checkbox-member:checked').length >= 1) {
        $('.js-membership-new').html('Renouvellement d\'adhésion')
      } else {
        $('.js-membership-new').html('Nouvelle adhésion')
      }
    });

    $('.js-membership-new').on('click', function (e) {
      e.preventDefault();
      var $url = [];
      $('.js-checkbox-member:checked').each(function () {
        $url.push($(this).val());
      })
      var full_url = '/adhesion/' + "?contacts=" + $url.join(',');
      window.location = full_url
    });

    /**
     * lien en _blank
     * pour les pdf, les liens externes, ..
     */
    let $pdfLinks = $('a[href$=".pdf"]'),
      $externalLinks = $('a[href^="http"]').not("a[href*='" + window.location.host + "']"),
      $makeIt_blank = $externalLinks.add($pdfLinks);

    $makeIt_blank.attr({
      target: '_blank',
      rel: 'noreferrer',
    });

    /**
    * add_class_to_image_links
    * used for automatic lightbox
    * exemple with Meow Lightbox, add just an existing class or create one and add in settings
    * @see https://meowapps.com/meow-lightbox-tutorial/#Selector
    */
    let $allLinks = $('a[href]');
    $allLinks.filter(function () {
      const $this = $(this);
      return /(jpg|jpeg|gif|png)$/i.test($this.attr('href'))
    }).addClass('gallery');

    // garde le label en haut si on touche le form (ça ca marche par contre)

    $(document).on('change', 'input[type="email"],input[type="text"],input[type="password"]', function () {
      if ($(this).val()) {

        $(this).parents('.input-wrap').addClass('input-wrap--labelled');
      } else {
        $(this).parents('.input-wrap').removeClass('input-wrap--labelled');
      }
    });

    // MODAL LOGIN/SIGNUP
    // rend le nom obligatoire
    if ($('#signup-last-name')) {
      $('#signup-last-name').prop('required', true);
    }

    // Désactive la touche "enter" si on est dans un input ou ailleurs qu'un textarea (un bouton radio par exemple)
    window.addEventListener('keydown', function (e) { if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) { if (e.target.nodeName == 'INPUT' && e.target.type !== 'textarea') { e.preventDefault(); return false; } } }, true);


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js